var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRug(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 6,
    width: 14,
    height: 12,
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 9,
    width: 8,
    height: 6,
    rx: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 8h2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12h2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 16h2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 8h2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19 12h2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19 16h2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRug);
export default __webpack_public_path__ + "static/media/rug.1acc044b2b334e48e35da64ee1466ad6.svg";
export { ForwardRef as ReactComponent };